export default __webpack_public_path__ + "static/13-cc9f528d348030417dce2ccf4d24706e.png";